<div class="statements-of-authorization-box">
    <div [innerHTML]="soaContent"></div>
</div>